export default class DataLayerEvent {
    constructor() {
        this.dataLayer = window.dataLayer || [];
    }

    cleanToFloat(value) {
        let cleaned = String(value)
            .replace(/[^0-9,.]/g, "")
            .replace(",", ".");
        return parseFloat(cleaned);
    }

    async fetchUserData() {
        try {
            const response = await fetch("/no-cache/get-details");
            if (!response.ok) {
                throw new Error("Network error: " + response.status);
            }
            const data = await response.json();
            return data?.data || null;
        } catch (error) {
            console.error("Error fetching user data:", error);
            return null;
        }
    }

    async addEvent(event, product, quantity, price) {
        const processedPrice = this.cleanToFloat(price);
        let unit_price = processedPrice;

        if (quantity > 1) {
            unit_price = Math.round((processedPrice / quantity) * 100) / 100;
        }
        const eventObject = {
            event: event,
            ecommerce: {
                currencyCode: "EUR",
                value: processedPrice,
                items: [
                    {
                        item_id: product.EAN ?? product.id,
                        item_name: product.name,
                        price: unit_price,
                        quantity: quantity,
                    },
                ],
            },
        };

        const userData = await this.fetchUserData();
        if (userData) {
            eventObject.user = userData;
        }

        this.dataLayer.push({ ecommerce: null });
        this.dataLayer.push(eventObject);
    }
}
